/*
 * @Author: liu.huirong
 * @Date: 2021-11-25 10:01:50
 * @Last Modified by: zhang.si
 * @Last Modified time: 2022-08-03 10:53:01
 * @Des: 头部标题组件
 * @param title 展示标题
 * @param hideGoHome 隐藏回商城首页的icon
 * @param hideGoBack 隐藏返回上一页的icon
 */
import React, { useEffect, useRef } from 'react';
import { connect, history } from 'umi';

import { isEmpty, get, head } from 'lodash';
import { getImgUrl, goBack } from '@/utils/utils';
import { TEMPLATE_NAME } from '@/utils/constants';
import { Clickable } from '@/components';
import backIcon from '@/assets/images/ic_back_export.png';
import arrowLeft from '@/assets/images/ic_bakc_arrow_left.png';
import closeIcon from '@/assets/images/ic_close@2x.png';
import shareIcon from '@/assets/images/ic_share@2x.png';
import styles from './index.less';

const Header = props => {
  const {
    title,
    titleColor,
    titleFontFamily,
    hideGoHome = false,
    goBack: propsGoback,
    hideGoBack = false,
    isShareObj = {},
    onlyGoBack = false,
    batchCreateUtmLink,
    activityDetail,
    playPrazeObj,
    isRegister = false,
    projectName,
    hideClose = false,
    isArrowLeft = false,
    isHiddenBorder = false,
  } = props;
  const GameI18n = JSON.parse(window.localStorage.getItem('GAME_i18n'));

  const marqueeContainerRef = useRef(null);
  const marqueeContentRef = useRef(null);

  const rawQuery = history.location.query || {};
  const needGoBack = !!rawQuery.needGoBack;
  const needGoBackByApp = !!rawQuery.needGoBackByApp;

  const handleGoBack = () => {
    if (needGoBackByApp) {
      goBack();
    } else if (needGoBack) {
      history.goBack();
    } else if (typeof propsGoback === 'function') {
      propsGoback();
    } else {
      history.goBack();
    }
  };

  // 右上角X号统一返回H5首页
  const handleGoHome = () => {
    if (hideClose) {
      return;
    }
    if (needGoBackByApp) {
      goBack();
    }
    if (isRegister || onlyGoBack || needGoBack) {
      history.goBack();
      // SF印尼金光
    } else if (projectName === 'SF') {
      // 印尼，印尼特殊处理
      window?.DIGIX?.invokeClientMethod('dxpClosePage');
    } else {
      window.localStorage.setItem('tabIndex', JSON.stringify(0));
      const callback = () => {
        history.push('/');
      };
      goBack(callback);
    }
  };

  const shareImg = () => {
    const { promotionId } =
      history.location.query || JSON.parse(localStorage.getItem('promotionId'));
    const initAppStr = window.localStorage.getItem('initApp');
    const initApp = JSON.parse(initAppStr) || {};
    if (promotionId) {
      localStorage.setItem('promotionId', JSON.stringify({ promotionId }));
    }
    batchCreateUtmLink({
      linkCode: 'Lucky Draw (Wheel,Grid)', // 目前只有大转盘九宫格有分享 可根据templateCode区分不通类型的模板
      needQRCode: 'N',
      paramMapList: [
        {
          seq: '1',
          paramMap: {
            msisdn: (initApp.prefix || '86') + (initApp.phone || initApp.mobile),
            promotionId,
            linkCode: 'Lucky Draw (Wheel,Grid)',
          },
        },
      ],
    }).then(resp => {
      const data = get(resp, 'data.linkList');
      // 新桥接 TODO 定向分享后期用到再重启，需要跟app那边重新联调
      if (window.dito || window.clp) {
        const shareParams = {
          shareContent: GameI18n?.shareBrief || get(isShareObj, 'brief'),
          shareLink: get(head(data), 'shortLink'),
          shareImageUrl: `${getImgUrl(get(isShareObj, 'serverUrl'), get(isShareObj, 'mediaUrl'))}`,
          // type: '2', // 0表示 原图, 1表示 商品 ,2表示 活动
          // filter: '4,5,6,7',
          // has_reward: playPrazeObj.hasPrize,
        };
        if (window.dito) {
          window.dito.shareOut(shareParams);
        } else if (window.clp) {
          window.clp.shareBySystem(JSON.stringify(shareParams));
        }
      }
      if (window.WebViewJavascriptBridge) {
        const params = {
          url: get(head(data), 'shortLink'),
          has_reward: playPrazeObj.hasPrize,
          imageUrl: `${getImgUrl(get(isShareObj, 'serverUrl'), get(isShareObj, 'mediaUrl'))}`,
          type: '2', // 0表示 原图, 1表示 商品 ,2表示 活动
          filter: '4,5,6,7',
          text: get(isShareObj, 'brief'),
        };
        window.connectJSBridge(bridge => {
          bridge.callHandler('share', params);
        });
      }
    });
  };
  // 目前只加上了大转盘九宫格
  const isNineOrWheel = code =>
    code === TEMPLATE_NAME.FRESH_SPRING_TEMPLATE ||
    code === TEMPLATE_NAME.FRESH_SPRING_TEMPLATE_N ||
    code === TEMPLATE_NAME.FESTIVE_SIMPLE_TEMPLATE ||
    code === TEMPLATE_NAME.FESTIVE_SIMPLE_TEMPLATE_N;

  const needShare = () => !isEmpty(isShareObj) && isNineOrWheel(activityDetail.templateCode);

  const getPaddingRight = () => {
    if (needShare()) {
      return 0;
    }
    if (hideGoHome) {
      return '0.16rem';
    }
    return 0;
  };

  useEffect(() => {
    const marqueeContainer = marqueeContainerRef.current;
    const marqueeContent = marqueeContentRef.current;

    if (!(marqueeContent && marqueeContainer)) {
      return;
    }

    // 检查内容宽度是否超过容器宽度
    if (marqueeContent.offsetWidth > marqueeContainer.offsetWidth) {
      marqueeContent.classList.add(styles.scroll);
    } else {
      marqueeContent.classList.remove(styles.scroll);
    }
  }, []);

  return (
    <header
      className={styles.header}
      style={{
        paddingLeft: hideGoBack ? '0.16rem' : 0,
        paddingRight: getPaddingRight(),
        border: isHiddenBorder ? 'none' : null,
      }}
    >
      <Clickable
        className={`${styles.imgBox} ${hideGoBack ? styles.hideGoBack : ''}`}
        onClick={handleGoBack}
      >
        <img alt="" src={isArrowLeft ? arrowLeft : backIcon} />
      </Clickable>
      {
        // SA_SHOW 商发项目
        projectName === 'SA_SHOW' ? (
          <div className={styles.marqueeContainer} ref={marqueeContainerRef}>
            <h3
              className={styles.marqueeContent}
              ref={marqueeContentRef}
              style={{ color: titleColor, fontFamily: titleFontFamily }}
            >
              {title}
            </h3>
          </div>
        ) : (
          <h3 title={title} style={{ color: titleColor, fontFamily: titleFontFamily }}>
            {title}
          </h3>
        )
      }

      {needShare() ? (
        <Clickable className={`${styles.imgBox}`} onClick={shareImg}>
          <img alt="" src={shareIcon} />
        </Clickable>
      ) : (
        <Clickable
          onClick={handleGoHome}
          className={`${styles.imgBox} ${hideGoHome ? styles.hideGoHome : ''}`}
        >
          {hideClose ? (
            <span style={{ width: '0.16rem' }} />
          ) : (
            <img alt="" style={{ width: '0.16rem' }} src={closeIcon} />
          )}
        </Clickable>
      )}
    </header>
  );
};

const mapDispatchToProps = dispatch => ({
  batchCreateUtmLink: payload =>
    dispatch({
      type: 'index/batchCreateUtmLink',
      payload,
    }),
});
export default connect(
  ({ index }) => ({
    activityDetail: index.activityDetail,
    projectName: index.projectName,
  }),
  mapDispatchToProps,
)(Header);
